export enum SoundType {
  AttackSlash = 'attackSlash',
  AttackPierce = 'AttackPierce',
  AttackBlunt = 'attackBlunt',
  AttackRend = 'attackRend',
  AttackSlap = 'attackSlap',
  AttackWings = 'AttackWings',
  AttackBlow = 'attackBlow',
  AttackString = 'attackString',
  AttackWeb = 'attackWeb',
  AttackMusic = 'AttackMusic',

  AttackFire = 'attackFire',
  AttackIce = 'attackIce',
  AttackLightning = 'attackLightning',
  AttackEarth = 'attackEarth',

  MagicFire = 'attackFire',
  MagicIce = 'attackIce',
  MagicLightning = 'attackLightning',
  MagicEarth = 'attackEarth',
  MagicChaos = 'attackChaos',

  PainBird = 'painBird',
  PainHumanMale = 'painHumanMale',
  PainInsect = 'painInsect',
  PainOrcMale = 'painOrcMale',

  // Defense sounds
  Block = 'defenseBlock',
  Dodge = 'defenseDodge',

  DiceSingle = 'diceSingle',
  DiceMultiple = 'diceMultiple',

  // UI sounds
  Button = 'button1',
  BattleStart = 'battleStart',
  Swish = 'swish',
  ManualOpen = 'manualOpen',
  ManualClose = 'manualClose',

  // Barks
  BarkDog = 'barkDog',
  BarkBird = 'barkBird',

  // Buffs
  BuffStrength = 'buffStrength',
  BuffAgility = 'buffAgility',
  BuffIntellect = 'buffIntellect',
  BuffArmour = 'buffArmour',
  BuffAim = 'buffAim',
  BuffMagic = 'buffMagic',
  BuffMusic = 'BuffMusic',

  // Misc
  GainStance = 'gainStance',
  GainAmmo = 'gainAmmo',

  // Healing
  Heal = 'heal',

  None = 'none',

  Song = 'song',
}
